import { BreadCrumb, BreadCrumbProps } from '@/components/BreadCrumb';
import { ContactForm } from '@/components/ContactForm';
import { IntroText } from '@/components/IntroText';
import { Layout } from '@/components/Layout';
import { PageCover } from '@/components/PageCover';
import { useLocaleField } from '@/hooks/useLocaleField';
import { GetContactPageQuery, getSdk } from '@/services/graphql';
import { graphqlClient } from '@/services/graphql-client';
import styles from '@/styles/Home.module.css';
import { Container } from '@chakra-ui/react';
import { FC } from 'react';
import BeSearchForm from '@/components/BeForms/BeSearchForm';

interface Props {
  contactPageData: GetContactPageQuery
}

const ContactPage: FC<Props> = ({ contactPageData }) => {
  const breadcrumb: BreadCrumbProps['items'] = [
    {
      link: '/',
      title: 'Home',
    },
    {
      link: '/contact',
      title: 'Contact',
    },
  ];

  const { getLocaleField } = useLocaleField();


  return (
    <Layout pageTitle="Contact">
      <main className={styles.main}>
        <PageCover data={contactPageData.ContactPage?.pageCover} />
        <BeSearchForm />
        <Container maxW="container.xl" mt="25px">
          <BreadCrumb items={breadcrumb} />
          <IntroText
            title={getLocaleField(contactPageData.ContactPage?.introText?.title) || ''}
            subtitle={getLocaleField(contactPageData.ContactPage?.introText?.subtitle) || ''}
            isCentered={contactPageData.ContactPage?.introText?.isCentered}
            description={contactPageData.ContactPage?.introText?.description}
          />
        </Container>
        <ContactForm/>
      </main>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const sdk = getSdk(graphqlClient);
  const { data: contactPageData } = await sdk.getContactPage();

  return {
    props: {
      contactPageData
    },
  };
};

export default ContactPage;
